var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.isChecked},on:{"change":_vm.emitChecked}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }